<template>
  <div class="dashboard">
    <h1>欢迎进入篱笆AI面试后台</h1>
  </div>

</template>

<script>

export default {
  name: 'dashboard',
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}

.dashboard {
  .admin-x {
    margin: 0 auto;
    width: fit-content;
  }
}

</style>
